export function formatPercents(value?: number, toFixed: number = 2) {
  if (!value) value = 0;
  return `${value.toFixed(toFixed)}\xa0%`;
}